import { useEffect, useRef } from 'react';

import { getSocket } from '#client';

type P = {
  token?: string;
};

const SocketConnection = ({ token }: P) => {
  const socket = getSocket();
  const authenticatedToken = useRef<null | string>(null);

  useEffect(() => {
    if (!socket.connected) {
      socket.connect();
    }

    return () => {
      socket.disconnect();
    };
  }, [socket]);

  useEffect(() => {
    const logout = () => {
      socket.emit('remove', 'authentication', null, {});
      authenticatedToken.current = null;
    };

    if (!token) {
      if (authenticatedToken.current && socket.connected) {
        logout();
      }

      return;
    }

    const login = () => {
      socket.emit('create', 'authentication', {
        accessToken: token,
        strategy: 'jwt',
      });
      authenticatedToken.current = token;
    };

    socket.on('connect', login);

    if (socket.connected) {
      login();
    } else {
      socket.connect();
    }

    return () => {
      socket.off('connect', login);
    };
  }, [socket, token]);

  return null;
};

export default SocketConnection;
